import { useMemo } from 'react';

import { DisputableTransaction } from '__generated__/GQL';

export const useDisputableTransactionsByDay = (
  transactions: DisputableTransaction[],
) => {
  return useMemo(
    () =>
      transactions.reduce(
        (dataSections, transaction) => {
          const date = new Date(transaction.transactionAt);
          const title = date?.toLocaleDateString();
          const section = dataSections.find((s) => s.title === title);
          if (section) {
            section.data.push(transaction);
          } else {
            dataSections.push({
              data: [transaction],
              date,
              title,
            });
          }
          return dataSections;
        },
        [] as { title: string; data: DisputableTransaction[]; date: Date }[],
      ),
    [transactions],
  );
};
